import { classifyRefusal } from "../errors";
import type { ApiRefusal } from "../errors";
import { hasWord, word } from "./word";

/**
 * Plain-language text for a refusal: its own words if we have them, then the case's, then generic. A refusal whose
 * `rule` param names which of its rules broke has words per rule (`refusal.CODE.RULE`), tried before the code's own.
 */
export function refusalWord(refusal: ApiRefusal, locale?: string): string {
  const { kind } = classifyRefusal(refusal);
  const caseCode = kind === "OTHER" || kind === "CONFLICT" || kind === "MAINTENANCE" ? "refusal.generic" : `refusal.${kind}`;
  const rule = refusal.params["rule"];
  const ruleCode = typeof rule === "string" ? `refusal.${refusal.code}.${rule}` : undefined;
  const code = ruleCode !== undefined && hasWord(ruleCode, locale) ? ruleCode : `refusal.${refusal.code}`;
  return word(code, refusal.params, locale, { fallbackCode: caseCode });
}
